import React from 'react';

import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { DashboardSection } from './DashboardSection';

import { Heading, Text } from '../../design-system/components/Typography';

import { Button } from '../../design-system/components/Button';

import { Stack } from '../../design-system/components/Layout';

import { spacing } from '../../design-system/tokens/spacing';

import { typography } from '../../design-system/tokens/typography';

import { DashboardProfileCompletionView } from '../../types/dashboard';



const Percentage = styled.p`

  font-size: ${typography.fontSize.metric};

  font-weight: ${typography.fontWeight.semibold};

  margin: ${spacing[2]} 0 0 0;

  color: ${props => props.theme.colors.text};

`;



const ProgressTrack = styled.div`

  width: 100%;

  height: 8px;

  background: ${props => props.theme.colors.surfaceHover};

  border-radius: 9999px;

  overflow: hidden;

  margin-top: ${spacing[3]};

`;



const ProgressFill = styled.div<{ $pct: number }>`

  height: 100%;

  width: ${props => props.$pct}%;

  background: ${props => props.theme.colors.primary};

  border-radius: 9999px;

  transition: width 200ms ease;

`;



const FieldList = styled.ul`

  margin: ${spacing[3]} 0 0 0;

  padding-left: ${spacing[5]};

  color: ${props => props.theme.colors.textSecondary};

  font-size: ${typography.fontSize.sm};

  line-height: ${typography.lineHeight.relaxed};

`;



interface ProfileCompletionCardProps {

  profileCompletion: DashboardProfileCompletionView;

  editPath?: string;

}



export const ProfileCompletionCard: React.FC<ProfileCompletionCardProps> = ({

  profileCompletion,

  editPath = '/profile/edit',

}) => {

  const { t } = useTranslation();

  const navigate = useNavigate();



  const { percentage, missingFieldLabels, remainingMessage } = profileCompletion;



  return (

    <DashboardSection>

      <Stack direction="column" spacing="md">

        <Heading variant="h3" as="h2" style={{ fontSize: typography.fontSize.section, margin: 0 }}>

          {t('dashboard.profileCompletion.title')}

        </Heading>



        <Percentage aria-hidden>{percentage}%</Percentage>



        <div

          role="progressbar"

          aria-valuenow={percentage}

          aria-valuemin={0}

          aria-valuemax={100}

          aria-label={t('dashboard.profileCompletion.title')}

        >

          <ProgressTrack>

            <ProgressFill $pct={percentage} />

          </ProgressTrack>

        </div>



        {missingFieldLabels.length > 0 && (

          <>

            <Text size="sm" color="secondary">

              {remainingMessage}

            </Text>

            <FieldList>

              {missingFieldLabels.map(label => (

                <li key={label}>{label}</li>

              ))}

            </FieldList>

          </>

        )}



        <Button

          variant="primary"

          size="md"

          onClick={() => navigate(editPath)}

          fullWidth

        >

          {t('dashboard.profileCompletion.completeProfile')}

        </Button>

      </Stack>

    </DashboardSection>

  );

};



export default ProfileCompletionCard;


